import { TranslateResult } from 'vue-i18n';
import { Conferences } from '@or-sdk/hitl';
import { AgentSearchOptions } from '@/types';

export type ConferenceMember = Conferences.Conference;
export type CALL_MEMBER_TYPE = Conferences.CALL_MEMBER_TYPE;
export const CALL_MEMBER_TYPE = Conferences.CALL_MEMBER_TYPE;
export type CALL_MEMBER_STATUS = Conferences.CALL_MEMBER_STATUS;
export const CALL_MEMBER_STATUS = Conferences.CALL_MEMBER_STATUS;

export interface PopupTab {
  readonly label?: string | TranslateResult;
  readonly key?: string;
  readonly code?: string;
}

export interface ListItemAction {
  readonly key: string;
  readonly label?: string | TranslateResult;
  readonly icon?: string;
  readonly color?: string;
}

export interface CallInfo {
  readonly from: string;
  readonly contactId: string;
  /** Session description as markdown */
  readonly description?: string;
  readonly tabs: {
    readonly invite: PopupTab[];
    readonly transfer: PopupTab[];
  };
  readonly controls: CallControlsSettings;
  readonly muted: boolean;
  readonly onHold: boolean;
}

export interface CallControlsSettings {
  readonly invite?: AgentCallActionsSettings;
  readonly transfer?: AgentCallActionsSettings;
  readonly mute?: boolean;
  readonly hold?: boolean;
  readonly emulateSoftPhone?: boolean;
}

export interface AgentCallActionsSettings {
  readonly allowAgent?: boolean;
  readonly allow3rdParty?: boolean;
  readonly agentSearchParams?: {
    readonly searchOptions?: AgentSearchOptions;
    readonly canChangeSearchOptions?: boolean;
  };
}
